import List from '@mui/material/List';
import {useUiWiseAppContext} from 'main/utility/AppContextProvider/UiWiseAppContextProvider';
import React from 'react';
import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import NavVerticalGroup from './VerticalNavGroup';

const VerticalNav = () => {
  const {uiWiseMenuSpec} = useUiWiseAppContext();

  return (
    <List
      sx={{
        position: 'relative',
        padding: 0,
      }}
      component='div'
    >
      {uiWiseMenuSpec.map((item) => (
        <React.Fragment key={item.layoutid}>
          {item.menutype === 'group' && (
            <NavVerticalGroup item={item} level={0} />
          )}

          {item.menutype === 'collapse' && (
            <VerticalCollapse item={item} level={0} />
          )}

          {item.menutype === 'item' && <VerticalItem item={item} level={0} />}
        </React.Fragment>
      ))}
    </List>
  );
};

export default VerticalNav;
